import { render, staticRenderFns } from "./PredefinedModals.vue?vue&type=template&id=f6da911c&scoped=true&"
import script from "./PredefinedModals.vue?vue&type=script&lang=ts&"
export * from "./PredefinedModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6da911c",
  null
  
)

export default component.exports